<template>
  <LLTabs2 v-model="internalTab" :items="tabs" :aria-label="$t('dashboard.tabs.aria')" @change="emitChange">
  </LLTabs2>
</template>

<script>
import LLTabs2 from '@/components/common/LLTabs2.vue'

export default {
  name: 'DashboardTabs',
  components: { LLTabs2 },
  props: {
    selectedTab: { type: String, default: 'studies' },
    studyAmount: { type: Number, default: 0 },
    chatAmount: { type: Number, default: 0 }
  },
  data() {
    return { internalTab: this.selectedTab }
  },
  computed: {
    tabs() {
      return [
        {
          key: 'studies',
          label: this.$t('dashboard.tabs.conversations'),
          badge: 0
        },
        {
          key: 'chats',
          label: this.$t('dashboard.tabs.chats'),
          badge: 0
        }
      ]
    }
  },
  watch: {
    selectedTab(v) {
      this.internalTab = v
    },
    internalTab(v) {
      this.$emit('update:selectedTab', v)
    }
  },
  methods: {
    emitChange(key, tab) {
      this.$emit('change', key, tab)
    }
  }
}
</script>
